import MemoryTile from './MemoryTile'
import TileScrim from './components/TileScrim'
import TileInfo from './components/TileInfo'
import ViewAllCover from './components/ViewAllCover'
import './locales'

export default MemoryTile
export { TileScrim, TileInfo, ViewAllCover }
